import { publicPages, siteOrigin, normalizePublicPath, canonicalPath } from './publicSite';

export const analyticsId = 'G-QN8XJERT1E';
const scriptId = 'orarivo-google-analytics';
// Public Google Analytics opt-out flag, not an API credential.
const analyticsDisabledFlag = 'ga-disable-G-QN8XJERT1E';
declare global {
  interface Window {
    dataLayer?: IArguments[];
    gtag?: (...args: any[]) => void;
    'ga-disable-G-QN8XJERT1E'?: boolean;
    __orarivoAnalytics?: { configured: boolean; lastPage?: string; guardsInstalled?: boolean };
  }
}
const denied = { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };

export const suspendAnalytics = (clearCookies = false) => {
  if (typeof window === 'undefined') return;
  window[analyticsDisabledFlag] = true;
  if (window.__orarivoAnalytics) window.__orarivoAnalytics.lastPage = undefined;
  if (!clearCookies) return;
  window.gtag?.('consent', 'update', denied);
  document.getElementById(scriptId)?.remove();
  // The tag uses host-only cookies at /; account/session storage is untouched.
  document.cookie.split(';').forEach(cookie => {
    const name = cookie.trim().split('=')[0];
    if (/^_ga(?:_|$)/.test(name)) document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
  });
};

export const trackPublicPage = (pathname: string) => {
  pathname = normalizePublicPath(pathname);
  const page = pathname === '/login' ? undefined : publicPages[pathname];
  if (!page || typeof window === 'undefined') { suspendAnalytics(); return; }
  window[analyticsDisabledFlag] = false;
  const state = window.__orarivoAnalytics ||= { configured: false };
  if (!state.guardsInstalled) {
    // Stop measurement before the SPA opens an account route, including history
    // navigation; do not let automatic tag events inspect private page content.
    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!link) return;
      const destination = new URL(link.getAttribute('href')!, window.location.href);
      if (destination.origin === window.location.origin && (!publicPages[normalizePublicPath(destination.pathname)] || normalizePublicPath(destination.pathname) === '/login')) suspendAnalytics();
    }, true);
    window.addEventListener('popstate', () => { if ((!publicPages[normalizePublicPath(window.location.pathname)] || normalizePublicPath(window.location.pathname) === '/login')) suspendAnalytics(); });
    state.guardsInstalled = true;
  }
  if (!window.gtag) {
    window.dataLayer ||= [];
    window.gtag = function () { window.dataLayer?.push(arguments); };
  }
  if (!state.configured) {
    window.gtag('consent', 'default', denied);
    window.gtag('js', new Date());
    window.gtag('consent', 'update', { ...denied, analytics_storage: 'granted' });
    window.gtag('config', analyticsId, {
      send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false,
      cookie_domain: 'none', cookie_path: '/', cookie_expires: 180 * 86400,
      page_location: `${siteOrigin}${canonicalPath(pathname)}`, page_title: page.title, page_referrer: '',
    });
    state.configured = true;
  } else {
    window.gtag('consent', 'update', { ...denied, analytics_storage: 'granted' });
  }
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId; script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
    script.onerror = () => script.remove(); // A later consent/page action can retry.
    document.head.appendChild(script);
  }
  if (state.lastPage === pathname) return;
  // Explicit public URLs only: no account IDs, query strings, hashes or referrers.
  window.gtag('event', 'page_view', {
    send_to: analyticsId, page_location: `${siteOrigin}${canonicalPath(pathname)}`, page_title: page.title, page_referrer: '',
  });
  state.lastPage = pathname;
};
